import type * as React from "react"

/**
 * Шапка страницы образца: заголовок на фоне полотна, под ним — вкладки, и
 * только потом белые панели с данными. Полоса заголовка отделена от контента
 * линией, а не тенью: тень тут читалась бы как «плавающая» панель.
 *
 * Заголовок рвётся где угодно, а кнопки при нехватке места уходят строкой
 * ниже: у карточки двойника заголовок — `transaction_id` в 32 символа без
 * пробелов, и на 360 px он вылезал за край, выдавливая кнопки в нулевую
 * ширину (Visual QA AMEND-59 шаг 2). Короткие заголовки это не трогает —
 * пока заголовок и кнопки помещаются в строку, переноса нет.
 */
export function PageHeader({
  title,
  tabs,
  actions,
}: {
  title: string
  tabs?: React.ReactNode
  actions?: React.ReactNode
}) {
  return (
    <div className="border-b border-line bg-canvas px-5 pt-4">
      <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-3">
        <h1 className="text-[22px] font-semibold leading-7 tracking-[-0.01em] text-fg [overflow-wrap:anywhere]">
          {title}
        </h1>
        {actions}
      </div>
      <div className="mt-3">{tabs}</div>
    </div>
  )
}
